import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const faqs = [
    {
      question: t("faq1.q1"),
      answer: t("faq1.a1")
    },
    {
      question: t("faq1.q2"),
      answer: t("faq1.a2")
    },
    {
      question: t("faq1.q3"),
      answer: t("faq1.a3")
    },
    {
      question: t("faq1.q4"),
      answer: t("faq1.a4")
    },
    {
      question: t("faq1.q5"),
      answer: t("faq1.a5")
    },
    {
      question: t("faq1.q6"),
      answer: t("faq1.a6")
    },
    {
      question: t("faq1.q7"),
      answer: t("faq1.a7")
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <h1 className="text-3xl font-bold mb-6">{t("faq1.title")}</h1>
      <div className="w-full max-w-3xl">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4 border-b pb-4">
            <button
              className="w-full text-left text-lg font-semibold p-4 bg-white shadow-md rounded-md"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
            </button>
            {openIndex === index && (
              <p className="p-4 text-gray-700 bg-gray-50 rounded-md mt-2">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
